import Store from 'store/store';

const fire = (action, cat, label) => {
	if (!window.firePowsterCustomEvent) return;
	window.firePowsterCustomEvent(action, cat, label);
};

// View
Store.on('TRACK_QUIZPHOTOBOOTH_VIEW', (cat) => {
	fire('view', cat, '-');
});

// Intro
Store.on('TRACK_QUIZPHOTOBOOTH_NAME_CLICK', () => {
	fire('name-click', 'name', '-');
});

Store.on('TRACK_QUIZPHOTOBOOTH_START_CLICK', () => {
	fire('start-button-click', 'name', '-');
});

// Quiz
Store.on('TRACK_QUIZPHOTOBOOTH_ANSWER_CLICK', ({ questionNum, answer }) => {
	fire('answer-click', 'quiz', `question-${questionNum}_${answer}`);
});

// Results
Store.on('TRACK_QUIZPHOTOBOOTH_RESULT_REVEAL', (result) => {
	fire('result-reveal', 'results', result);
});

Store.on('TRACK_QUIZPHOTOBOOTH_RESULT_SHARE', () => {
	fire('result-share-cta', 'results', '-');
});

// Photobooth Events
Store.on('TRACK_QUIZPHOTOBOOTH_UPLOAD_OR_TAKE_PHOTO', (action) => {
	fire('photo-options-click', 'results', action);
});

Store.on('TRACK_QUIZPHOTOBOOTH_CAMERA_PERMISSIONS', (allowOrDeny) => {
	fire('camera-permissions', 'camera', allowOrDeny);
});

Store.on('TRACK_QUIZPHOTOBOOTH_CAPTURE_PHOTO', () => {
	fire('photo-capture-click', 'camera', '-');
});

Store.on('TRACK_QUIZPHOTOBOOTH_FLIP_CAMERA', () => {
	fire('flip-camera', 'camera', '-');
});

Store.on('TRACK_QUIZPHOTOBOOTH_RETAKE_OR_CONTINUE', (retakeOrContinue) => {
	fire('resize-button-click', 'resize', retakeOrContinue);
});

Store.on('TRACK_QUIZPHOTOBOOTH_PINCH_ZOOM', () => {
	fire('pinch-zoom', 'resize', '-');
});

Store.on('TRACK_QUIZPHOTOBOOTH_ZOOM_CLICK', (plusOrMinus) => {
	fire('zoom-click', 'resize', plusOrMinus);
});

Store.on('TRACK_QUIZPHOTOBOOTH_ROTATE_TWIST', () => {
	fire('rotate-twist', 'resize', '-');
});

Store.on('TRACK_QUIZPHOTOBOOTH_ROTATE_CLICK', (dir) => {
	fire('rotate-click', 'resize', dir);
});

// Shareable Events
Store.on('TRACK_QUIZPHOTOBOOTH_RESULT_REVEAL_NO_INTERSTITIAL', () => {
	fire('result-share-cta', 'shareable', '-');
});

Store.on('TRACK_QUIZPHOTOBOOTH_CAROUSEL_SWIPE', () => {
	fire('share-card-carousel-swipe', 'shareable', '-');
});

Store.on('TRACK_QUIZPHOTOBOOTH_SHARE_CARD_CLICK', (type) => {
	fire('share-card-click', 'shareable', type);
});

Store.on('TRACK_QUIZPHOTOBOOTH_REDO_CLICK', () => {
	fire('redo-click', 'shareable', '-');
});

// Hub Events
Store.on('TRACK_HUB_TILE_CLICK', (title, path) => {
	fire('tile-click', 'tile', `${title}_${path}`);
});

Store.on('TRACK_HUB_TILE_BUTTON_CLICK', (btn, link) => {
	fire('tile-click', 'tile', `${btn}_${link}`);
});

Store.on('TRACK_HUB_CAROUSEL_ARROW_CLICK', (carouselHeader) => {
	fire('carousel-engagement', 'carousel', `${carouselHeader}`);
});

// MISC
Store.on('TRACK_QUIZPHOTOBOOTH_ERROR_BACK', (screen) => {
	fire('error-screen-back', `${screen}-error`, 'back-home');
});

Store.on('TRACK_QUIZPHOTOBOOTH_LOGO_CLICK', () => {
	fire('logo-home', 'header', 'back-home');
});

// TIMELINE
Store.on('TRACK_TIMELINE_TOGGLE_CLICK', (timeline) => {
	fire('timeline_toggle', 'timeline', timeline);
});

Store.on('TRACK_TIMELINE_SCROLLER_CLICK', () => {
	fire('timeline_sidescroller_select', 'timeline', '-');
});

Store.on('TRACK_TIMELINE_CARD_VIEW', (card) => {
	fire('timeline_event_view', 'timeline', card);
});

Store.on('TRACK_TIMELINE_ADDITIONALINFO_CLICK', (cardTitle, cardDestination) => {
	fire('timeline_event_additionallink', 'timeline', `${cardTitle}_${cardDestination}`);
});

Store.on('TRACK_TIMELINE_ADDITIONALINFO_RETURN_CLICK', (cardTitle, cardDestination) => {
	fire('timeline_event_additionallink_return', 'timeline', `${cardTitle}_${cardDestination}`);
});

Store.on('TRACK_TIMELINE_BUTTON_CLICK', (cardTitle, buttonLabel, buttonLink) => {
	fire('timeline_event_button', 'timeline', `${cardTitle}_${buttonLabel}_${buttonLink}`);
});

Store.on('TRACK_TIMELINE_SCROLL_PROGRESS', (progress, timeline) => {
	fire('timeline_event_view', 'timeline', `${progress}_${timeline}`);
});